<template>
  <div>
    <div class="customer-info">
      <div class="customer-info-item">
        <div class="customer-info-title">
          <!--图标-->
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-qiyexinxi"></use>
          </svg>
          <span>项目设置</span>
        </div>
        <div class="flex jend acenter">
          <div class="group-oper-box flex center mr10 pointer" @click="showGroupModal('add')">
            <svg class="icon">
              <use xlink:href="#icon-tianjiajihua"></use>
            </svg>
            添加分组
          </div>
          <!--展开-->
          <svg v-if="show" class="icon" aria-hidden="true" @click="changeShow">
            <use xlink:href="#icon-zhankaizhuangtai"></use>
          </svg>
          <!--收起-->
          <svg v-else class="icon" aria-hidden="true" @click="changeShow">
            <use xlink:href="#icon-shouqizhuangtai"></use>
          </svg>
        </div>
      </div>
    </div>
    <div class="items" v-if="show">
      <draggable
        tag="el-row"
        :gutter="40"
        :list="itemLists"
        class="itemLists"
        group="setItems"
      >
        <el-col class="itemBox" v-for="(emp,i) in itemLists" :key="emp.id" v-if="emp.dismiss !== '10020001'">
          <div class="itemTitle">
            <span class="title-text flex acenter">{{emp.name}} {{wagesFrom.twoLanguage === '10020001' ? emp.enName : ''}}</span>
            <div class="group-oper-box flex jend acenter">
              <div class="flex center mr10 pointer" @click="settingItem(emp,i)">
                <svg class="icon">
                  <use xlink:href="#icon-setting"></use>
                </svg>
                设置项目
              </div>
              <div class="flex center mr10 pointer" @click="showGroupModal('edit', emp, i)">
                <svg class="icon">
                  <use xlink:href="#icon-xiugai"></use>
                </svg>
                编辑分组
              </div>
              <div class="flex center mr10 pointer" @click="dismissGroup(emp,i)">
                <svg class="icon">
                  <use xlink:href="#icon-shanchu"></use>
                </svg>
                解散分组
              </div>
            </div>
          </div>
          <!--<el-row >-->
          <draggable
            tag="el-row"
            :gutter="40"
            :list="emp.itemList"
            class="itemLists"
            :group="'setItem'+emp.id"
          >
            <el-col :span="emp.showType === '0' ? 24 : 12"
                    class="itemList"
                    v-for="element in emp.itemList"
                    :key="element.id"
            >
              <div class="itemListBox">
                <p>{{element.itemNameCh}} {{wagesFrom.twoLanguage === '10020001' ? element.itemNameEn : ''}}</p>
              </div>

            </el-col>
          </draggable>
          <!--</el-row>-->
        </el-col>
      </draggable>
    </div>
    <el-dialog
      ref="itemDialog"
      width="70%"
      id="choose"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="设置显示项目"
      :visible.sync="dialogheaderVisible"
    >
      <chooseBox :dynamic-tags="dynamicTags" :choose-lists="chooseListShow"></chooseBox>
      <div
        class="marginTop30"
        style="text-align: center"
      >
        <el-button
          type="primary"
          @click="saveChoose()"
        >
          确认
        </el-button>
        <el-button @click="cancel()">
          取消
        </el-button>
      </div>
    </el-dialog>

    <!-- 新增和修改 -->
    <el-dialog
      :title="groupModalTitle"
      :visible.sync="groupModalShow"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
    >
      <el-form
        :model="groupForm"
        ref="groupForm"
        :rules="groupFormRules"
        class="editForm"
        label-width="150px"
        label-suffix="："
      >
        <el-form-item label="分组名称" prop="name" style="margin-bottom: 30px;">
          <el-input v-model="groupForm.name" placeholder="请输入分组名称"></el-input>
        </el-form-item>
        <el-form-item label="分组英文名称" prop="enName" style="margin-bottom: 30px;">
          <el-input v-model="groupForm.enName" placeholder="请输入分组英文名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitGroupForm">确 定</el-button>
        <el-button @click="groupModalShow = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import chooseBox from "./chooseBox";
import {getChooseLists, getChooseDatas, getPayrollLists} from "@/api/wage/salaryTemplate";
import {deepCopy} from "@/util/util";

export default {
  name: "paySquenceItem",
  components: {draggable, chooseBox},
  props: {
    idx: {
      type: Number,
      default: 0
    },
    itemLists: {
      type: Array,
      default: function () {
        return [];
      }
    },
    wagesFrom: {
      type: Array,
      default: function () {
        return {};
      }
    },
    itemIndex: {
      type: Number,
      default: function () {
        return 0;
      }
    }
  },
  data() {
    return {
      show: true,
      dialogheaderVisible: false,
      dynamicTags: [],
      chooseLists: [],
      chooseListShow: [],
      groupModalShow: false,
      groupModalTitle: '',
      groupOperType: '',
      groupIndex: undefined,
      groupForm: {
        name: '',
        enName: ''
      },
      groupFormRules: {
        name: [
          { required: true, message: '请输入分组名称', trigger: 'blur' },
        ]
      }
    };
  },
  created() {
    console.log("----", this.itemLists);
    //重新启用整体加载薪资项的方式
    this._getChooseLists();
  },
  methods: {
    changeShow() {
      this.show === true ? this.show = false : this.show = true;
    },
    settingItem(emp, i) {
      this.itemIndex = i;
      //console.log("settingItem----");
      //console.log("emp", emp)
      //console.log("Lists", this.chooseLists);
      this.chooseListShow = deepCopy(this.chooseLists);
      for (let i in this.chooseListShow) {
        let list = this.chooseListShow[i].chooseList
        if(list == "undefined") {
          list = list.filter((item) => {
            for(let j in emp.chList){
            let chose = emp.chList[j].chooseList;
            if (chose == "undefined") {
              if (item.itemId == chose.itemId) {
                console.log(chose.name)
                return false;
              }
            }
          }
          return true;
        });
          this.chooseListShow[i]['chooseList'] = list;
        }
      }
      this.dynamicTags = emp.chList;
      this.dialogheaderVisible = true;
    },
    showGroupModal(type, group, index) {
      this.groupOperType = type
      console.log(group)
      if (type === 'add') {
        this.groupModalTitle = '添加分组'
        this.groupForm = {
          add: '10020001',
          name: '',
          enName: '',
          chList: [],
          itemList: []
        }
      } else {
        this.groupIndex = index
        this.groupModalTitle = '编辑分组'
        this.groupForm = deepCopy(group)
      }
      this.groupModalShow = true
    },
    dismissGroup(group) {
      this.$confirm(`确定解散分组【${group.name}】吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        group.dismiss = '10020001'
        this.$forceUpdate()
      })
    },
    submitGroupForm() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          let group = {}
          if (this.groupOperType === 'add') {
            this.itemLists.unshift(deepCopy(this.groupForm))
          } else {
            group = this.itemLists[this.groupIndex]
          }
          group.name = this.groupForm.name
          group.enName = this.groupForm.enName
          this.groupModalShow = false
        }
      })
    },
    //启用 获取薪资项
    _getChooseLists() {
      console.log("获取薪资项----");
      getPayrollLists().then(res => {
        let rs = res.data;
        if (rs.code == 0) {
          console.log("工资单data====", res.data.data);
          this.chooseLists = res.data.data;
        } else {
          this.$message.error('获取薪资项出现问题')
        }
      })
    },
    saveChoose() {
      console.log("dynamicTags-----", this.dynamicTags);
      var selectArr = [];
      this.dynamicTags.map(function (item) {
        selectArr.push(item.chooseList)
      })
      this.itemLists[this.itemIndex].itemList = selectArr;
      this.dialogheaderVisible = false
    },
    cancel() {
      console.log("dynamicTags-----", this.dynamicTags);
      this.dialogheaderVisible = false
    }
  }
};
</script>

<style lang="scss" scoped>
.itemBox {
  padding: 0 10px;
}

.itemLists {
  margin-top: 20px;
}

.itemList {
  margin-bottom: 20px;
  padding: 0 20px;
  cursor: move;

  p {
    color: #666666;
    font-size: 12px;
  }
  p + p {
    color: #000000;
    font-size: 14px;
  }
}

.itemListBox {
  background-color: #f3f3f3;
  display: flex;
  justify-content: space-between;
  line-height: 30px;
  padding: 0 20px;
  border-radius: 2px;
}

.itemTitle {
  height: 30px;
  background: #FFEDBE;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;

  .title-text {
    color: #000000;
    font-size: 14px;
    flex: 1;
    cursor: move;
  }
}
.group-oper-box {
  color: #AA5401;
  font-size: 12px;
  line-height: 12px;

  .icon {
    margin-right: 5px;
  }
}
</style>
